import React, { useEffect } from 'react'

import { datadogRum } from '@datadog/browser-rum'
import {
  AlignItems,
  Box,
  Button,
  Display,
  FlexDirection,
  Heading1,
  Join,
  Space,
  Body1,
} from '@gousto-internal/citrus-react'

type MenuErrorProps = {
  onRefresh: () => void
}

export const MenuError = ({ onRefresh }: MenuErrorProps) => {
  useEffect(() => {
    datadogRum.addError(new Error('MenuError Page displayed: Something went wrong'), {})
  }, [])

  return (
    <Box
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      alignItems={AlignItems.Center}
      paddingV={4}
    >
      <Join with={<Space size={3} />}>
        <Heading1>Something went wrong</Heading1>
        <Body1>Try to reload the data to resolve the issue.</Body1>
        <Button onClick={onRefresh} data-testid="refreshMenu">
          Refresh
        </Button>
      </Join>
    </Box>
  )
}
